import { Create, Edit, List, View, NoteSheet } from "../Components/index.js";

export default [
    { path: "/voucher/store/received", component: List, name: "voucher.store.received" },
    { path: "/voucher/store/received/create", component: Create, name: "voucher.store.received.create" },
    { path: "/voucher/store/received/:id/edit", component: Edit, name: "voucher.store.received.edit" },
    { path: "/voucher/store/received/:id/view", component: View, name: "voucher.store.received.view" },

    {
        path: "/voucher/store/received/:id/note-sheet",
        component: NoteSheet,
        name: "voucher.store.received.note-sheet"
    }
];
